import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PasswordSettingService {

  patternValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$');
      const valid = regex.test(control.value);
      return valid ? null : { invalidPassword: true };
    };
  }

  validateDifferentPassword(currentPassword: string, password: string) {
    return (formGroup: UntypedFormGroup) => {
      const currentPasswordControl = formGroup.controls[currentPassword];
      const passwordControl = formGroup.controls[password];
      const sameOldPassword = currentPasswordControl.value === passwordControl.value;
      if (sameOldPassword) {
        passwordControl.setErrors({ ...passwordControl.errors, sameOldPassword });
      }
    };
  }

  MatchPassword(password: string, confirmPassword: string) {
    return (formGroup: UntypedFormGroup) => {
      const passwordControl = formGroup.controls[password];
      const confirmPasswordControl = formGroup.controls[confirmPassword];

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (confirmPasswordControl.errors && !confirmPasswordControl.errors.passwordMismatch) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    };
  }
}
